export enum POSVendor {
  BRINK = 'BRINK',
  CARROLS = 'CARROLS',
  NCR = 'NCR',
  QDI = 'QDI',
  SICOM = 'SICOM',
}
